import {put, fork, takeEvery} from "redux-saga/effects";
import {VolumeAction} from "../state/volume";
import {Storage, ToStorage} from "./storage";

export function* volume() {
    yield takeEvery<VolumeAction>("Volume", function (value){
        const newVolume = parseFloat(`${value.payload}`);
        ToStorage("rczpv", newVolume);
    });

    yield fork (Storage, "rczpv", function*(value: any) {
        if (value) {
            let newVolume = parseFloat(value);
            try {
                yield put<VolumeAction>({
                    type: "Volume",
                    payload: newVolume
                })
            } finally {

            }
        } else {
            yield put<VolumeAction>({
                type: "Volume",
                payload: 1
            })
        }
    });
}